import { DeepPartial } from "@towersystems/roam-common/lib/shared-types";
import {
  EftTerminalType,
  KeyHandlingType,
  NetworkType,
  TerminalCommsType,
} from "../../types";
import { PosApiResponseWithResult } from "../pos-api-response-with-result";

export class StatusResponse extends PosApiResponseWithResult {
  constructor(input?: DeepPartial<StatusResponse>) {
    super(input);
    // Re-apply after super(): subclass field declarations reset declared
    // properties to undefined once super() returns, wiping the values
    // BaseResponse copied. Re-assigning here restores the API payload.
    if (input) {
      Object.assign(this, input);
    }
  }

  public Merchant: string;

  public Aiic?: string;

  /**
   * The NII that is configured in the terminal.
   * @example 0
   */
  public NII: number;

  /**
   * Terminal ID configured in the PIN pad.
   * @example 12345678
   */
  public CatId: string | null;

  /**
   * Merchant ID configured in the PIN pad.
   * @example 0123456789ABCDEF
   */
  public CaId: string | null;

  /**
   * The bank response timeout that is configured in the terminal.
   * @example 45
   */
  public Timeout: number;

  /**
   * Indicates if the PIN pad is currently logged on.
   */
  public LoggedOn: boolean;

  /**
   * The serial number of the terminal.
   * @example 1234567890ABCDEF
   */
  public PinPadSerialNumber: string | null;

  /**
   * PIN pad software version.
   * @example 100800
   */
  public PinPadVersion: string | null;

  /**
   * The bank acquirer code.
   */
  public BankCode: string | null;

  /**
   * The bank description.
   */
  public BankDescription: string | null;

  /**
   * Key verification code.
   */
  public KVC: string;

  /**
   * Current number of stored transactions.
   */
  public SafCount: number;

  /**
   * PIN pad terminal network option.
   */
  public NetworkType: NetworkType;

  /**
   * The hardware serial number.
   * @example ABCDEF1234567890
   */
  public HardwareSerial: string | null;

  /**
   * The merchant retailer name.
   * @example Example Retailer
   */
  public RetailerName: string | null;

  /**
   * PIN pad terminal supported options flags.
   */
  //public OptionsFlags: PinPadOptionFlags;

  /**
   * Store-and forward credit limit.
   */
  public SafCreditLimit: number;

  /**
   * Store-and-forward debit limit.
   */
  public SafDebitLimit: number;

  /**
   * The maximum number of store transactions.
   */
  public MaxSaf: number;

  /**
   * The terminal key handling scheme.
   */
  public KeyHandlingScheme: KeyHandlingType;

  /**
   * The maximum cash out limit.
   */
  public CashoutLimit: number;

  /**
   * The maximum refund limit.
   */
  public RefundLimit: number;

  /**
   * Card prefix table version.
   */
  public CpatVersion: string | null;

  /**
   * Card name table version.
   */
  public NameTableVersion: string | null;

  /**
   * The terminal to PC communication type.
   */
  public TerminalCommsType: TerminalCommsType;

  /**
   * Number of card mis-reads.
   */
  public CardMisreadCount: number;

  /**
   * Number of memory pages in the PIN pad terminal.
   */
  public TotalMemoryInTerminal: number;

  /**
   * Number of free memory pages in the PIN pad terminal.
   */
  public FreeMemoryInTerminal: number;

  /**
   * The type of PIN pad terminal.
   */
  public EftTerminalType: EftTerminalType;

  /**
   * Number of applications in the terminal.
   */
  public NumAppsInTerminal: number;

  /**
   * Number of available display lines on the terminal.
   */
  public NumLinesOnDisplay: number;

  /**
   * Hardware inception date.
   */
  public HardwareInceptionDate: Date;
}
